import { Link, Outlet } from 'react-router-dom';
import { useTenantEntity } from './tenant-entity-provider';

export function NotAuthorised() {
  return <div className="mx-auto mt-8 w-full max-w-lg rounded-lg border p-6 text-center" role="alert">
    <h1 className="text-lg font-semibold">Not authorised</h1>
    <p className="mt-2 text-sm text-muted-foreground">You do not have permission to open this page.</p>
    <Link className="mt-4 inline-block text-sm underline underline-offset-4" to="/">Return home</Link>
  </div>;
}
export function RequirePermission({ permission, permissions }: { permission?: string; permissions?: string[] }) {
  const { status, hasPermission } = useTenantEntity();
  if (status === 'loading' || status === 'switching' || status === 'idle') return <div role="status">Checking access…</div>;
  return status === 'ready' && (permission ? hasPermission(permission) : permissions?.some(hasPermission))
    ? <Outlet /> : <NotAuthorised />;
}

export function RequireModule({ moduleKey }: { moduleKey: string }) {
  const { status, hasModule } = useTenantEntity();
  if (status === 'loading' || status === 'switching' || status === 'idle') return <div role="status">Checking module access…</div>;
  if (status === 'ready' && hasModule(moduleKey)) return <Outlet />;
  return <div className="mx-auto mt-8 w-full max-w-lg rounded-lg border p-6 text-center" role="alert">
    <h1 className="text-lg font-semibold">Module unavailable</h1>
    <p className="mt-2 text-sm text-muted-foreground">This module is not enabled for your tenant.</p>
    <Link className="mt-4 inline-block text-sm underline underline-offset-4" to="/">Return home</Link>
  </div>;
}
